import r from "../../../utilities/tw.js";
const o = {
  inputBase: r`min-w-0 grow cursor-text bg-transparent font-medium placeholder:font-regular placeholder:text-disabled focus-visible:outline-none`,
  inputWrapper: r`flex w-full cursor-text items-center gap-2 rounded border-2 border-background-inverse bg-surface px-4 py-3 focus-within:border-primary-active focus-within:outline-none hover:border-primary-hover`,
  inputWrapperDisabled: r`pointer-events-none cursor-default border-disabled bg-disabled-surface text-disabled focus-within:border-disabled hover:border-disabled `,
  inputWrapperDisplayOnly: r`pointer-events-auto border-none bg-secondary p-0 text-neutral-inverse focus-visible:outline-transparent`,
  inputWrapperError: r`border-error bg-error-surface text-error focus-within:border-error hover:border-error`,
  wrapper: r`flex flex-col gap-1`
};
export {
  o as textFieldStyles
};
